/** Same-origin API (nginx proxies /api → backends). */
export const API_BASE = (() => {
  const env = process.env.REACT_APP_BACKEND_URL;
  if (env && env.trim()) {
    return `${env.replace(/\/$/, "")}/api`;
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/api`;
  }
  return "/api";
})();

export function formatApiError(detail, fallback) {
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => (typeof item === "string" ? item : item?.msg || JSON.stringify(item)))
      .join(". ");
  }
  if (typeof detail === "object" && detail.message) return detail.message;
  return fallback;
}
